import {
  canonicalQueryString,
  dashboardSwrKey,
  DASHBOARD_VIEW_MAP,
} from "../utils/dashboardQueryKeys";
import { sanitizeDashboardDateRangeForQuery } from "../utils/dashboardDateRange";

export const OPERATOR_PORTAL = {
  DASHBOARD: "operator/portal/dashboard/",
  WALLET: "operator/portal/wallet/",
  WALLET_TRANSACTIONS: "operator/portal/wallet/transactions/",
  WALLET_TRANSACTIONS_EXPORT: "operator/portal/wallet/transactions/export/",
  PAYMENTS: "operator/portal/payments/",
  PAYMENTS_TRANSACTIONS: "operator/portal/payments/transactions/",
  PAYMENTS_TRANSACTIONS_EXPORT: "operator/portal/payments/transactions/export/",
};

export function mapTimeFrameToView(timeFrame) {
  if (timeFrame === "C") return "custom";
  return DASHBOARD_VIEW_MAP[timeFrame] || "weekly";
}

export function buildOperatorPortalQueryString({
  timeFrame,
  scope,
  filters,
  walletUsageView,
  paymentTrendView,
  policyTrendView,
}) {
  const p = new URLSearchParams();

  if (scope) p.set("region", scope);

  const view = mapTimeFrameToView(timeFrame);
  if (view) p.set("view", view);

  const { startStr, endStr } = sanitizeDashboardDateRangeForQuery(
    filters?.startDate,
    filters?.endDate
  );
  if (startStr) p.set("start_date", startStr);
  if (endStr) p.set("end_date", endStr);

  const walletView = mapTimeFrameToView(walletUsageView);
  const paymentView = mapTimeFrameToView(paymentTrendView);
  const policyView = mapTimeFrameToView(policyTrendView ?? timeFrame);

  if (walletView) p.set("wallet_usage_view", walletView);
  if (paymentView) p.set("payment_trend_view", paymentView);
  if (policyView) p.set("policy_trend_view", policyView);

  return canonicalQueryString(p);
}

export function operatorPortalUrl(path, queryCanon = "") {
  return dashboardSwrKey(path, queryCanon);
}
